export enum NotificationTypeEnum {
  LIGHTING_OVERRIDE = 1,
  SOFT_DIMMING = 2,
  LIGHT_INTENSITY = 3,
  TIME_DELAY = 4,
  MOTION_SENSOR = 5,
  PHOTO_SENSING = 6,
  RAIN_SENSOR = 7,

  TIMER_PROFILE = 8,
  DIMMING_PROFILE = 9,
  LUMINANCE_PROFILE = 10,
  DAY_LIGHT_PROFILE = 11,
  RAIN_PROFILE = 12,
  DAY_LIGHT_HARVEST = 13,
  TRIGGER_ZONE = 14,
  LIGHTING_ZONE = 15,
}

export const WEBSOCKET_MAX_RETRY_COUNT = 5;
